import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment reactionFields on RecognitionFeedReaction {
    uuid
    createdBy {
      uuid
      firstname
      lastname
    }
    emoji {
      code
      name
    }
  }
`

export default fragment
